<template>
    <div id="historical-databooks-view" class="page">
        <h1>Historical Data Books</h1>
	
        <ul class="download-list">			
			    <li v-for="(item, index) in data" :key="index">			

            <div class="heading">
					    {{ item.title }}
				    </div>
				
				    <div class="download-buttons">
               <a href="#" @click.prevent="downloadFile(item.year, item.files[0].name, item.files[0].extType)" class="btn-download btn-pdf" rel="noopener">
                    <img :src="baseURL + '/static/img/acrobat.png'" srcset="static/img/acrobat@2x.png 2x" alt="Download PDF"><span>Download PDF</span>
               </a>

              <a href="#" @click.prevent="downloadFile(item.year, item.files[1].name, item.files[1].extType)" class="btn-download btn-ppt" rel="noopener">
                    <img src="static/img/powerpoint.png" srcset="static/img/powerpoint@2x.png 2x" alt="Download PowerPoint"><span>Download PPT</span>
              </a>
           </div>

		    </li>			
        </ul>
    </div>
</template>

<script>

import axios from 'axios';

export default {
    name: 'HistoricalDataBooks',
    data () {
        return {
            pageTitle: 'Historical Data Books',
            baseURL: window.baseURL,
            baseApiURL : (window.location.hostname === 'localhost' ? 'https://localhost:59971' : window.location.origin),
			      data: null,
        };
    },
    mounted () {
        document.title = this.$parent.pageTitle + ' - ' + this.pageTitle;
		    this.fetchData(); // Fetch data on component mount
    },
	methods: {
    async fetchData() {
      let apiUrl = this.baseApiURL + '/reportweb/api/databook/getallhistoricalfiles';      
      const response = await axios.get(apiUrl);
			this.data = response.data;
		},
		
    downloadFile(keyId, name, type) {
      let downloadButton = document.createElement('a');
      downloadButton.setAttribute('href', encodeURI(this.baseApiURL + "/reportweb/api/databook/downloadFile?keyId=" + keyId + '&docType=' + type));
      downloadButton.setAttribute('download', name);      
      downloadButton.setAttribute('style', 'opacity: 0;');

      document.body.appendChild(downloadButton);
      downloadButton.click();
      downloadButton.parentElement.removeChild(downloadButton);
		}	
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.download-list {
    list-style: none;
    margin: 30px 0;
    padding: 0;

    .heading {
        display: inline-block;
        margin-right: 15px;
        margin-bottom: 0;
        font-size: 18px;
        color: #333;
        vertical-align: top;
    }

    .sub-heading {
        display: block;
        margin-top: -4px;
        font-size: 12px;
        color: #6d6d6d;
        font-weight: 600;
    }

    > li {
        margin-bottom: 25px;
    }
}

.download-buttons {
    display: inline-block;
    a {
        text-decoration: none;
    }
}

.btn-download {
    display: inline-block;
    padding: 6px 10px;
    background-color: #fff;
    color: #ad1700;
    border-radius: 4px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
    transition: 0.3s;
    vertical-align: top;

    + .btn-download {
        margin-left: 6px;
    }

    &:hover,
    &:focus {
        text-decoration: none;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.25);
    }

    img {
        margin-right: 5px;
    }
}
</style>
